<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M220.207 5.98975H36.1343V217.301H220.207V5.98975Z"
      class="fill-brand-500"
    />
    <path
      d="M36.1343 5.98975V123.284C71.8364 123.544 107.668 84.5103 112.195 5.98975H36.1343Z"
      class="fill-secondary-500"
    />
    <path
      d="M220.208 5.98975H144.082C148.609 84.5751 184.506 123.673 220.208 123.284V5.98975Z"
      class="fill-secondary-500"
    />
    <path
      d="M229.65 240.384H26.6916C23.5224 240.384 21 237.855 21 234.678V219.117C21 215.94 23.5224 213.411 26.6916 213.411H229.65C232.82 213.411 235.342 215.94 235.342 219.117V234.678C235.342 237.855 232.82 240.384 229.65 240.384Z"
      class="fill-brand-300"
    />
    <path
      d="M82.7417 194.32L77.0327 200.597L104.325 225.543L110.034 219.266L82.7417 194.32Z"
      class="fill-brand-300"
    />
    <path
      d="M71.6428 208.678C81.9303 208.678 90.27 200.317 90.27 190.004C90.27 179.691 81.9303 171.33 71.6428 171.33C61.3553 171.33 53.0156 179.691 53.0156 190.004C53.0156 200.317 61.3553 208.678 71.6428 208.678Z"
      class="fill-brand-300"
    />
    <path
      d="M71.6427 197.655C75.8577 197.655 79.2747 194.23 79.2747 190.004C79.2747 185.779 75.8577 182.353 71.6427 182.353C67.4277 182.353 64.0107 185.779 64.0107 190.004C64.0107 194.23 67.4277 197.655 71.6427 197.655Z"
      class="fill-brand-500"
    />
    <path
      d="M139.684 232.668L120.41 253.871C119.698 254.649 118.599 254.843 117.758 254.39L82.832 233.317C81.7972 232.668 81.6678 231.177 82.5733 230.204L112.584 197.201C113.489 196.229 114.977 196.164 115.688 197.136L139.942 230.01C140.525 230.788 140.395 231.89 139.684 232.668Z"
      class="fill-secondary-500"
    />
    <path
      d="M220.208 140.985L203.521 138.521C197.441 137.614 191.297 138.846 186.123 141.763C180.431 142.606 173.187 142.606 168.983 138.457C165.49 135.02 164.456 128.99 165.814 120.496C167.301 111.354 165.878 103.832 161.61 98.0617C157.47 92.4855 150.744 88.9193 142.206 87.7522C139.619 87.428 137.226 89.2435 136.838 91.8371C136.515 94.4307 138.326 96.8298 140.913 97.2188C145.052 97.8023 150.679 99.3585 153.913 103.768C156.565 107.399 157.406 112.521 156.371 119.005C154.495 130.676 156.5 139.494 162.256 145.265C165.814 148.766 170.6 150.906 176.421 151.554C174.222 155.445 172.993 159.918 172.993 164.652V175.221C172.605 175.48 172.217 175.674 171.829 175.934C167.625 178.463 164.65 179.824 161.998 184.104C159.023 188.837 157.082 195.191 155.142 200.378C153.202 206.279 161.351 209.65 164.132 204.074C165.167 201.805 166.202 199.471 167.301 197.201C170.729 189.68 174.351 188.707 182.048 187.67C187.222 186.957 191.426 186.762 196.536 185.725C201.192 184.817 204.879 181.51 206.625 177.62C210.441 178.981 215.098 179.759 220.208 179.824V140.985Z"
      class="fill-brand-100"
    />
  </svg>
</template>

<script>
  export default {
    name: 'AccidentPlant'
  }
</script>
